var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 38,
    viewBox: "0 0 70 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9801 1.37751C22.9801 0.616733 23.5969 0 24.3577 0C25.1184 0 25.7352 0.616733 25.7352 1.37751V35.8153C25.7352 36.5761 25.1184 37.1928 24.3577 37.1928C23.5969 37.1928 22.9801 36.5761 22.9801 35.8153V1.37751Z",
    fill: "url(#paint0_linear_341_11852)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4701 5.51005C17.4701 4.74927 18.0868 4.13254 18.8476 4.13254C19.6084 4.13254 20.2251 4.74927 20.2251 5.51005V31.6828C20.2251 32.4436 19.6084 33.0603 18.8476 33.0603C18.0868 33.0603 17.4701 32.4436 17.4701 31.6828V5.51005Z",
    fill: "url(#paint1_linear_341_11852)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.96 9.64259C11.96 8.88181 12.5768 8.26508 13.3376 8.26508C14.0983 8.26508 14.7151 8.88181 14.7151 9.64259V27.5503C14.7151 28.311 14.0983 28.9278 13.3376 28.9278C12.5768 28.9278 11.96 28.311 11.96 27.5503V9.64259Z",
    fill: "url(#paint2_linear_341_11852)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44999 13.7751C6.44999 13.0143 7.06673 12.3976 7.8275 12.3976C8.58828 12.3976 9.20502 13.0143 9.20502 13.7751V23.4177C9.20502 24.1785 8.58828 24.7952 7.8275 24.7952C7.06673 24.7952 6.44999 24.1785 6.44999 23.4177V13.7751Z",
    fill: "url(#paint3_linear_341_11852)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.939941 17.9077C0.939941 17.1469 1.55668 16.5302 2.31745 16.5302C3.07823 16.5302 3.69497 17.1469 3.69497 17.9077V19.2852C3.69497 20.046 3.07823 20.6627 2.31745 20.6627C1.55668 20.6627 0.939941 20.046 0.939941 19.2852V17.9077Z",
    fill: "url(#paint4_linear_341_11852)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0606 17.9077C67.0606 17.1469 67.6773 16.5302 68.4381 16.5302C69.1988 16.5302 69.8156 17.1469 69.8156 17.9077V19.2852C69.8156 20.046 69.1988 20.6627 68.4381 20.6627C67.6773 20.6627 67.0606 20.046 67.0606 19.2852V17.9077Z",
    fill: "url(#paint5_linear_341_11852)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2854 5.51004C53.2854 4.74926 52.6686 4.13253 51.9079 4.13253C51.1471 4.13253 50.5304 4.74926 50.5304 5.51004V31.6828C50.5304 32.4436 51.1471 33.0603 51.9079 33.0603C52.6686 33.0603 53.2854 32.4436 53.2854 31.6828V5.51004Z",
    fill: "url(#paint6_linear_341_11852)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7954 9.64257C58.7954 8.88179 58.1787 8.26506 57.4179 8.26506C56.6571 8.26506 56.0404 8.8818 56.0404 9.64258V27.5502C56.0404 28.311 56.6571 28.9278 57.4179 28.9278C58.1787 28.9278 58.7954 28.311 58.7954 27.5502V9.64257Z",
    fill: "url(#paint7_linear_341_11852)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3055 13.7751C64.3055 13.0143 63.6887 12.3976 62.928 12.3976C62.1672 12.3976 61.5504 13.0143 61.5504 13.7751V23.4177C61.5504 24.1785 62.1672 24.7952 62.928 24.7952C63.6887 24.7952 64.3055 24.1785 64.3055 23.4177V13.7751Z",
    fill: "url(#paint8_linear_341_11852)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0002 19.2852C34.0002 18.5244 34.617 17.9077 35.3778 17.9077C36.1385 17.9077 36.7553 18.5244 36.7553 19.2852V35.8153C36.7553 36.5761 36.1385 37.1928 35.3778 37.1928C34.617 37.1928 34.0002 36.5761 34.0002 35.8153V19.2852Z",
    fill: "url(#paint9_linear_341_11852)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0002 5.51005C34.0002 4.74927 34.617 4.13254 35.3778 4.13254C36.1385 4.13254 36.7553 4.74927 36.7553 5.51005V11.0201C36.7553 11.7809 36.1385 12.3976 35.3778 12.3976C34.617 12.3976 34.0002 11.7809 34.0002 11.0201V5.51005Z",
    fill: "url(#paint10_linear_341_11852)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0204 28.9278C45.0204 28.167 45.6371 27.5503 46.3979 27.5503C47.1586 27.5503 47.7754 28.167 47.7754 28.9278V34.4378C47.7754 35.1986 47.1586 35.8153 46.3979 35.8153C45.6371 35.8153 45.0204 35.1986 45.0204 34.4378V28.9278Z",
    fill: "url(#paint11_linear_341_11852)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7754 17.9077C47.7754 18.6684 47.1586 19.2852 46.3979 19.2852C45.6371 19.2852 45.0204 18.6684 45.0204 17.9077V1.37751C45.0204 0.616734 45.6371 0 46.3979 0C47.1586 0 47.7754 0.616733 47.7754 1.37751V17.9077Z",
    fill: "url(#paint12_linear_341_11852)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5103 1.37751C39.5103 0.616733 40.127 0 40.8878 0C41.6486 0 42.2653 0.616733 42.2653 1.37751V35.8153C42.2653 36.5761 41.6486 37.1928 40.8878 37.1928C40.127 37.1928 39.5103 36.5761 39.5103 35.8153V1.37751Z",
    fill: "url(#paint13_linear_341_11852)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4902 1.37751C28.4902 0.616733 29.1069 0 29.8677 0C30.6285 0 31.2452 0.616733 31.2452 1.37751V35.8153C31.2452 36.5761 30.6285 37.1928 29.8677 37.1928C29.1069 37.1928 28.4902 36.5761 28.4902 35.8153V1.37751Z",
    fill: "url(#paint14_linear_341_11852)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9801 1.37751C22.9801 0.616733 23.5969 0 24.3577 0H29.8677C30.6285 0 31.2452 0.616733 31.2452 1.37751C31.2452 2.13829 30.6285 2.75503 29.8677 2.75503H24.3577C23.5969 2.75503 22.9801 2.13829 22.9801 1.37751Z",
    fill: "url(#paint15_linear_341_11852)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9801 17.9077C22.9801 17.1469 23.5969 16.5302 24.3577 16.5302H29.8677C30.6285 16.5302 31.2452 17.1469 31.2452 17.9077C31.2452 18.6684 30.6285 19.2852 29.8677 19.2852H24.3577C23.5969 19.2852 22.9801 18.6684 22.9801 17.9077Z",
    fill: "url(#paint16_linear_341_11852)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0002 35.8153C34.0002 35.0546 34.617 34.4378 35.3778 34.4378H40.8878C41.6486 34.4378 42.2653 35.0546 42.2653 35.8153C42.2653 36.5761 41.6486 37.1928 40.8878 37.1928H35.3778C34.617 37.1928 34.0002 36.5761 34.0002 35.8153Z",
    fill: "url(#paint17_linear_341_11852)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7754 1.37751C47.7754 2.13829 47.1586 2.75503 46.3979 2.75503H40.8878C40.127 2.75503 39.5103 2.13829 39.5103 1.37751C39.5103 0.616733 40.127 0 40.8878 0L46.3979 0C47.1586 0 47.7754 0.616733 47.7754 1.37751Z",
    fill: "url(#paint18_linear_341_11852)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7553 15.1526C36.7553 15.9134 36.1385 16.5302 35.3778 16.5302C34.617 16.5302 34.0002 15.9134 34.0002 15.1526C34.0002 14.3919 34.617 13.7751 35.3778 13.7751C36.1385 13.7751 36.7553 14.3919 36.7553 15.1526Z",
    fill: "url(#paint19_linear_341_11852)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7754 23.4177C47.7754 24.1785 47.1586 24.7952 46.3979 24.7952C45.6371 24.7952 45.0204 24.1785 45.0204 23.4177C45.0204 22.6569 45.6371 22.0402 46.3979 22.0402C47.1586 22.0402 47.7754 22.6569 47.7754 23.4177Z",
    fill: "url(#paint20_linear_341_11852)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_341_11852",
    x1: 35.9977,
    y1: 4.33918,
    x2: 51.744,
    y2: 12.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283890"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsLogo);
export default __webpack_public_path__ + "static/media/as_logo.7c78184083b1e441bb11f4d6c1b457df.svg";
export { ForwardRef as ReactComponent };